// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1N05Z","choiceBoxes":"toolbarselects_choiceBoxes__3Ukz3","simpleField":"toolbarselects_simpleField__gJIJ1"};